// extracted by mini-css-extract-plugin
module.exports = {"customerItem":"profilecustomer_customerItem__27uWe","customerItemIcon":"profilecustomer_customerItemIcon__3lkFo","customerItemActive":"profilecustomer_customerItemActive__m1TdP"};